module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Create task","label":{"progressStep":"Progress step","taskType":"Task type","selectRole":"Select role"},"placeholder":{"taskTitle":"Task title","startTyping":"Start typing to search document name","taskSubTitle":"Task subtitle (optional)"}}}')
  delete Component.options._Ctor
}
